export default __webpack_public_path__ + "static/ande-headshot-9fa02fcb226fdde425e65baf267b771b.png";